<!--
@todo Bu component Reusable bir component olacak. @bugFixMali

1- title parametreesi prop'dan alınacak. zorunlu
2- subtitle parametresi prop'dan alınacak. zorunlu olmayacak.
3- default slot custom-modal-body içine gelmeli
4- footeri için ayrı bir slot olmalı
5- footer açılıp kapanabilir olmalı. (propdan alınacak ) show-footer=true,show-footer=false

-->

<template>
    <a-modal :visible="true" :footer="null" @cancel="handleCancel" class="v2">
        <div class="custom-modal-content">
            <div class="custom-modal-header">
                <div class="title">{{ $t("message.assignPreferredAgent") }}</div>
                <div class="subtitle">{{ $t("message.selectPreferredAgent") }}</div>
            </div>
            <div class="custom-modal-body">
                <div class="pf-main">
                    <div class="pr-search">
                        <input :placeholder="$t('message.searchRepresentativePlaceholder')" v-model="searchText" @input="searchChange" />
                        <span class="material-icons mx-2 pr-icon"> search </span>
                    </div>
                    <hr />
                    <div class="pr-items pr-item-wrapper">
                        <div class="pr-item" v-for="agent of filterUsers" @click="toggleAgent(agent._id)">
                            <a-checkbox
                                class="segment-checkbox"
                                @click="toggleAgent(agent._id)"
                                :checked="selectedAgentIds.includes(agent._id)"
                            />

                            <div class="user-data-wrapper">
                                <div class="user-data">
                                    <Avatar
                                        :size="30"
                                        :src="agent.gravatar"
                                        :username="agent.name"
                                        class="mr-2 avatar"
                                    />
                                    <div class="metas">
                                        <div class="pr-item-name">{{ agent.name }}</div>
                                        <div>
                                            {{ getUserDepartmentNames(agent) }}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="pr-item-status"
                                    :data-online="$_.get(user, '_id') === agent._id ? true : agent.isOnline"
                                    :data-status="agent.status.toLowerCase()"
                                >
                                    <div class="pr-item-status-circle"></div>
                                    {{ agent.status }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="custom-modal-footer">
                <div class="actions">
                    <a-button @click="handleCancel">{{ $t("message.cancel") }}</a-button>
                    <a-button class="pr-confirm-btn" @click="handleConfirm" type="primary" :disabled="!isChanged()">
                        {{ $t("message.confirm") }}
                    </a-button>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import log2 from "../utils/log2";
import Avatar from "vue-avatar";

const log = log2("PreferredAgentsFormModal");
import { mapGetters, mapState, mapActions } from "vuex";
import _ from "lodash";
import { sendSocketMessage } from "../utils/socketStream";

export default {
    name: "PreferredAgentsFormModal",
    props: {
        visitorId: {
            type: String,
            default: null,
        },
        value: {
            type: Array,
        },
    },
    emits: ["cancel"],
    components: {
        Avatar,
    },
    data() {
        return {
            searchText: null,
            selectedAgentIds: _.cloneDeep(this.value || []),
            filterUsers: [],
        };
    },

    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            users: (state) => state.user.users.data,
            user: (state) => state.auth.user,
            subjects: (state) => state.subject.subjects.data,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            updatePreferredAgents: "visitor/updatePreferredAgents",
        }),
        getUserDepartmentNames(user) {
            return (user.subjects || []).length
                ? this.subjects
                      .filter((x) => (user.subjects || []).includes(x._id))
                      .map(
                          (x) =>
                              _.get(x, `languageContent.${this.$i18n.locale}.name`) ||
                              _.get(x, `languageContent.${Object.keys(x.languageContent)[0]}.name`)
                      )
                      .join(",")
                      .toLowerCase()
                : this.$t("message.allDepartments");
        },
        async save() {
            return await this.updatePreferredAgents({
                visitorId: this.visitorId,
                userIds: this.selectedAgentIds,
            }).then((data) => {
                sendSocketMessage("user sync-visitor", {
                    siteId: this.site._id,
                    visitorId: this.visitorId,
                });
                return data;
            });
        },
        toggleAgent(agentId) {
            this.selectedAgentIds = this.selectedAgentIds.includes(agentId)
                ? this.selectedAgentIds.filter((x) => x !== agentId)
                : [...this.selectedAgentIds, agentId];
        },
        searchChange() {
            let q = this.searchText.split("").join(".*");
            this.filterUsers = this.users.filter((x) => new RegExp(q, "gi").test(x.name));
        },
        handleConfirm() {
            this.save();
            this.$emit("input", this.selectedAgentIds);
            this.$emit("cancel");
        },
        handleCancel() {
            this.visible = false;
            this.$emit("cancel");
        },
        isChanged() {
            return !_.isEqual(this.selectedAgentIds, this.value);
        },
    },
    mounted() {
        this.filterUsers = this.users;
    },
    watch: {
        value: {
            deep: true,
            handler(val) {
                if (_.isEqual(this.selectedAgentIds, val)) return;
                this.selectedAgentIds = _.cloneDeep(val || []);
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.pf-main {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    border: 1px solid var(--color-border-default);
    padding: 5px;

    .pr-search {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;

        input {
            border: 1px solid #c6cdd4 !important;
            width: 100%;
            padding: 10px;
            padding-right: 40px;
            border-radius: 5px;
            transition: all 0.3s;
        }

        input:focus {
            border: 1px solid black !important;
        }

        .pr-icon {
            position: absolute;
            right: 4px;
        }
    }

    .pr-items {
        min-height: 300px;
        max-height: 300px;
        overflow: auto;

        .pr-item:last-child {
            border-bottom: none;
        }

        .pr-item {
            display: flex;
            justify-content: start;
            align-items: center;
            flex-wrap: nowrap;
            padding: 5px 10px;
            border-radius: 4px;
            cursor: pointer;
            gap: 10px;
            border-bottom: 1px solid var(--color-border-default);

            &:hover {
                background: var(--color-bg-neutral-hover);
            }

            .user-data-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;

                padding: 0 5px;

                .user-data {
                    display: flex;
                    gap: 5px;
                    align-items: center;

                    .avatar {
                        color: var(--color-text-onprimary-default);
                    }

                    .metas {
                        display: flex;
                        flex-direction: column;
                    }
                }
            }

            .pr-item-status {
                display: flex;
                justify-content: center;
                align-items: center;

                .pr-item-status-circle {
                    width: 10px;
                    height: 10px;
                    border-radius: 100%;
                    margin-right: 2px;
                }

                &[data-online="true"] {
                    &[data-status="online"] {
                        color: #1bc5bd !important;

                        .pr-item-status-circle {
                            background: #1bc5bd !important;
                        }
                    }

                    &[data-status="away"] {
                        color: #3699ff !important;

                        .pr-item-status-circle {
                            background: #3699ff !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: #ffa829 !important;

                        .pr-item-status-circle {
                            background: #ffa829 !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: #f64e60 !important;

                        .pr-item-status-circle {
                            background: #f64e60 !important;
                        }
                    }
                }

                &:not([data-online]) {
                    &[data-status="online"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="away"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
.ant-modal-root.v2 {
    .ant-modal-close-x {
        position: absolute;
        color: white;
        font-size: 20px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 4px;

        &:hover {
            background: var(--color-bg-ghost-hover);
        }
    }

    .ant-modal-body {
        padding: 0 !important;
        font-size: 14px;
        font-weight: 400;
        color: var(--color-text-default);
        line-height: 24px;
    }

    .ant-modal-content {
        border-radius: 4px;
    }

    .custom-modal-content {
        display: flex;
        flex-direction: column;

        .custom-modal-header {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 20px;
            border-bottom: 1px solid var(--color-border-default);

            .title {
                font-weight: 700;
                color: var(--color-text-strong-default);
                font-size: 24px;
                line-height: 32px;
            }
        }

        .custom-modal-body {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 20px;
            background: var(--color-bg-neutral-default);
        }

        .custom-modal-footer {
            border-top: 1px solid var(--color-border-default);
            padding: 20px;

            .actions {
                display: flex;
                gap: 5px;
                width: 100%;
                justify-content: flex-end;
            }
        }
    }
}
</style>
